import { axios, createFormData, handleError } from '../axios';

export const seriesTrashAll = (data) => {
  return new Promise((resolve) => {
    axios
      .post('admin/series/trash_all/', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
